import React from "react";
import { Route } from "react-router-dom";
import { EndPoints } from "../../../utils/apiEndpoints";
import Users from "../../Pages/Users/Users";
import Assets from "../../Pages/Assets/Assets";
import AddAsset from "../../Pages/Assets/AddAsset";
import AddTicket from "../../Pages/Tickets/AddTicket";
import ProfileUser from "../../Pages/Users/ProfileUser";
import ManageUsers from "../../Pages/Users/ManageUsers";
import Statuses from "../../Pages/Settings/Tickets/Statuses";
import AssetsRaport from "../../Pages/Raports/AssetsRaports";
import TicketRaports from "../../Pages/Raports/TicketRaports";
import AssetTypes from "../../Pages/Settings/Assets/AssetTypes";
import Locations from "../../Pages/Settings/Tickets/Locations";
import Companies from "../../Pages/Settings/General/Companies";
import Vendors from "../../Pages/Settings/Procurements/Vendors";
import Priorities from "../../Pages/Settings/Tickets/Priorities";
import Categories from "../../Pages/Settings/Tickets/Categories";
import Departments from "../../Pages/Settings/Tickets/Departments";
import CompanyNews from "../../Pages/Settings/General/CompanyNews";
import Contractors from "../../Pages/Settings/Tickets/Contractors";
import AssetStatuses from "../../Pages/Settings/Assets/AssetStatuses";
import AddSubTicket from "../../Pages/Tickets/SubTicket/AddSubTicket";
import TicketCalendar from "../../Pages/TicketCalendar/TicketCalendar";
import AssetLocations from "../../Pages/Settings/Assets/AssetLocations";
import Customers from "../../Pages/Settings/Tickets/Customers/Customers";
import AssetCategories from "../../Pages/Settings/Assets/AssetCategories";
import AssetActionTypes from "../../Pages/Settings/Assets/AssetActionTypes";
import AddCustomer from "../../Pages/Settings/Tickets/Customers/AddCustomer";
import InterventionType from "../../Pages/Settings/Tickets/InterventionType";
import AssetDepartments from "../../Pages/Settings/Assets/AssetDepartments";
import VendorStatuses from "../../Pages/Settings/Procurements/VendorStatuses";
import EvaluationCriterias from "../../Pages/Settings/Procurements/EvaluationCriterias";

const {
  ASSETS,
  USERS,
  ADDUSER,
  MANAGEUSERS,
  COMPANYNEWS,
  COMPANY,
  TICKETCALENDARS,
  VENDORS,
  VENDORSTATUSES,
  ADDTICKET,
  ADDASSET,
  ASSETLOCATIONS,
  ASSETCATEGORIES,
  ASSETTYPES,
  ASSETSTATUSES,
  TICKETRAPORTS,
  ASSETACTIONTYPES,
  ASSETSRAPORTS,
  CATEGORIES,
  CONTRACTORS,
  CUSTOMERS,
  ADDCUSTOMERS,
  INTERVENTIONTYPE,
  TICKETS,
  LOCATIONS,
  STATUSES,
  PRIORITIES,
  DEPARTMENTS,
  ASSETDEPARTMENTS,
  SUBTICKET,
  EVALUATIONCRITERIAS,
} = EndPoints;

export const AuthenticatedAdminRoutes = () => (
  <React.Fragment>
    <Route path={`${EVALUATIONCRITERIAS}`} element={<EvaluationCriterias />} />
    <Route path={`${VENDORS}`} element={<Vendors />} />
    <Route path={`${VENDORSTATUSES}`} element={<VendorStatuses />} />

    <Route path={`${ADDTICKET}`} element={<AddTicket />} />

    <Route path={`${TICKETS}/:id${SUBTICKET}/add`} element={<AddSubTicket />} />
    <Route path={`${TICKETS}/edit/:id${SUBTICKET}/:subticketId`} element={<AddSubTicket />} />
    <Route path={`${TICKETS}/view/:id${SUBTICKET}/:subticketId`} element={<AddSubTicket view={true} />} />

    <Route path={ASSETS} element={<Assets />} />
    <Route path={ADDASSET} element={<AddAsset />} />
    <Route path={`${ASSETS}/edit/:id`} element={<AddAsset />} />
    <Route path={`${ASSETS}/view/:id`} element={<AddAsset view={true} />} />

    <Route path={ASSETDEPARTMENTS} element={<AssetDepartments />} />
    <Route path={ASSETLOCATIONS} element={<AssetLocations />} />
    <Route path={ASSETCATEGORIES} element={<AssetCategories />} />
    <Route path={ASSETTYPES} element={<AssetTypes />} />
    <Route path={ASSETSTATUSES} element={<AssetStatuses />} />
    <Route path={ASSETACTIONTYPES} element={<AssetActionTypes />} />
    <Route path={TICKETCALENDARS} element={<TicketCalendar />} />

    <Route path={TICKETRAPORTS} element={<TicketRaports />} />
    <Route path={ASSETSRAPORTS} element={<AssetsRaport />} />
    <Route path={CATEGORIES} element={<Categories />} />
    <Route path={CONTRACTORS} element={<Contractors />} />

    <Route path={CUSTOMERS} element={<Customers />} />
    <Route path={`${ADDCUSTOMERS}`} element={<AddCustomer mode="Add" />} />
    <Route path={`${CUSTOMERS}/edit/:id`} element={<AddCustomer mode="Edit" />} />
    <Route path={`${CUSTOMERS}/view/:id`} element={<AddCustomer mode="View" />} />

    <Route path={INTERVENTIONTYPE} element={<InterventionType />} />
    <Route path={LOCATIONS} element={<Locations />} />
    <Route path={STATUSES} element={<Statuses />} />
    <Route path={PRIORITIES} element={<Priorities />} />
    <Route path={DEPARTMENTS} element={<Departments />} />
    <Route path={MANAGEUSERS} element={<ManageUsers />} />
    <Route path={USERS} element={<Users />} />
    <Route path={ADDUSER} element={<ProfileUser mode="ADD" />} />
    <Route path={`${USERS}/edit/:email`} element={<ProfileUser mode="EDIT" />} />
    <Route path={`${USERS}/view/:email`} element={<ProfileUser mode="VIEW" />} />
    <Route path={`${COMPANYNEWS}`} element={<CompanyNews />} />
    <Route path={COMPANY} element={<Companies />} />
  </React.Fragment>
);
